import { takeEvery } from 'containers/ErrorBoundary';
import { closeDialogue } from 'containers/LeaveDialogue/actions';
import { push } from 'redux-first-history';
import { reset, setSubmitFailed, startSubmit, stopSubmit } from 'redux-form';
import { all, call, put, select } from 'redux-saga/effects';
import { requestForSaga } from 'utils/request/request';
import { requestCustomErrorMessage } from 'utils/request/requestCustomErrorMessage';
import { requestMessage } from 'utils/request/requestMessage';
import syslogFormName from './Syslog/formName';
import { SAVE_SYSLOG } from './constants';

const syslogTime = (trigger, triggerTime, cron) => {
  switch (trigger) {
    case 'syslogtrigger':
      return { trigger, time: null };
    case 'timer':
      return { trigger, time: triggerTime };
    case 'schedule':
      return { trigger, cron };
    default:
      return null;
  }
};

function* saveSyslogSaga(action) {
  try {
    const { trigger, triggerTime, cron, returnUrl } = action.payload;
    yield put(startSubmit(syslogFormName));
    yield call(requestForSaga, {
      url: '/settings',
      method: 'PATCH',
      data: { syslog: syslogTime(trigger, triggerTime, cron) },
    });
    yield put({
      type: `${SAVE_SYSLOG}_SUCCESS`,
      payload: action.payload,
    });
    yield call(requestMessage, 'success', 'savedAdvancedSyslog');
    yield put(reset(syslogFormName));
    if (returnUrl) {
      yield put(
        push(
          { pathname: returnUrl.pathname, search: returnUrl.search },
          returnUrl.state,
        ),
      );
    }
    yield put(stopSubmit(syslogFormName));
  } catch (e) {
    const leaveDialogueOpen = yield select((s) =>
      s.getIn(['leaveDialogue', 'open']),
    );
    if (leaveDialogueOpen) {
      yield put(closeDialogue());
    }
    yield put(setSubmitFailed(syslogFormName));
    yield put(stopSubmit(syslogFormName));
    yield call(requestCustomErrorMessage, 'danger', e);
    throw e;
  }
}

export function* defaultSaga() {
  yield all([takeEvery(SAVE_SYSLOG, saveSyslogSaga)]);
}

export default defaultSaga;
